import { Component, OnInit, OnDestroy } from '@angular/core';
import { AccountService } from '../_services/account.service';
import { HeaderData } from 'src/app/_models/header-data';
import { RESULTS_NOT_FOUND } from 'src/app/_common/product-config';
import { BehaviorSubject } from 'rxjs';
import { PageCriteria } from 'src/app/_models/page-criteria';
import { BillingType, StatusCode } from 'src/app/_common/_enum/module.enum';

export enum ActivityView {
  InstallmentSchedule = "Direct",
  MonthlyReporter = "Monthly Reporter",
  InstallmentScheduleBtn = "Installment Plan",
  MonthlyReporterBtn = "Monthly Reporter",
}

@Component({
  selector: 'app-account-activity',
  templateUrl: './account-activity.component.html',
  styleUrls: ['./account-activity.component.scss']
})
export class AccountActivityComponent implements OnInit, OnDestroy {
  //Create HeaderData object to show the Data on Blue Header.
  private headerData:HeaderData;
  private selectedAccount;
  private activities = [];
  private loading: boolean = false;
  resultsNotFound = RESULTS_NOT_FOUND;
  private directcriteria: PageCriteria;
  private mrcriteria: PageCriteria;
  private hasActivities: boolean = true;
  private mrActivities: any = [];
  private directActivities: any = [];
  private billingTypeEnum = BillingType;
  private selectedView: string;
  private accHasInstallmentPlan: boolean = false;
  private accHasMonthlyReporter: boolean = false;
  hasAccess:boolean = false;

  constructor(private accountService: AccountService) { }

  ngOnInit() {
    this.selectedAccount = this.accountService.getAccountData();
    console.log('this.selectedAccount :: ', this.selectedAccount);
    /* Setting Headers Starts */
    this.headerData = new HeaderData();
    this.setHeaderData();
    /* Setting Headers Ended */

    this.directcriteria = new PageCriteria();
    this.mrcriteria = new PageCriteria();

    this.fetchAccountActivity();
  }
  setHeaderData(){
    this.headerData.pageTitle = "Account Activity";
    this.headerData.breadcrumb = [{itemName: this.selectedAccount.accountName, itemLink: "accounts/"+this.selectedAccount.accountNumber+"/policies"},
      {itemName: "Direct Bill", itemLink: "accounts/"+this.selectedAccount.accountNumber+"/directbill"}];

    this.accountService.header = this.headerData;
  }

  get ActivityViewEnum(){
    return ActivityView;
  }

  fetchAccountActivity(){
    this.loading = true;
    this.hasActivities = true;
    this.directActivities = [];
    this.mrActivities = [];
    let accountActivitySubscription = this.accountService.fetchAccountActivity(this.selectedAccount.accountNumber).subscribe((activities:any) => {
      this.loading = false;
      this.activities = activities;      
      this.hasAccess = true;
      this.activities.forEach(activity => {
        if(activity.billType === this.billingTypeEnum.Direct) {
          this.directActivities.push(activity);
        } else if(activity.billType === this.billingTypeEnum.MonthlyReporter) {
          this.mrActivities.push(activity);
        }
      });

      this.setActiveTab();
      console.log('this.directActivities :: ', this.directActivities);
      console.log('this.mrActivities :: ', this.mrActivities);
      this.hasActivities = this.activities.length > 0;
    },error=>{
      this.loading = false;
      this.hasActivities = false;
      this.hasAccess = !(error.status == StatusCode.NoAccess);
    });

    this.accountService.runningServices.push(accountActivitySubscription);
  }

  setActiveTab() {
    if (this.selectedAccount && this.selectedAccount.billType) {
      this.selectedAccount.billType.forEach(type => {
        if (type === this.billingTypeEnum.Direct) this.accHasInstallmentPlan = true;
        if (type === this.billingTypeEnum.MonthlyReporter) this.accHasMonthlyReporter = true;
      });

      if(this.selectedAccount.billType.length > 1 || this.accHasInstallmentPlan) {
        this.selectedView = ActivityView.InstallmentSchedule;
      } else {
        this.selectedView = ActivityView.MonthlyReporter;
      }
    } else {
      if(this.directActivities.length > 0 && this.mrActivities.length > 0) {
        this.selectedView = ActivityView.InstallmentSchedule;
        this.accHasInstallmentPlan = true;
        this.accHasMonthlyReporter = true;
      } else if (this.directActivities.length > 0) {
        this.selectedView = ActivityView.InstallmentSchedule;
        this.accHasInstallmentPlan = true;
      } else {
        this.selectedView = ActivityView.MonthlyReporter;
        this.accHasMonthlyReporter = true;
      }
    }
  }

  onPageChange(){
    window.scrollTo(0, 0);
  }

  ngOnDestroy() {
    this.accountService.runningServices.forEach(subscription =>subscription.unsubscribe());
  }
}
